<template>
<aside class="sidebar menu">
  <h1 class="logo">snitch<span class="dot">.</span></h1>
  <p class="menu-label">
    General
  </p>
  <ul class="menu-list">
    <li>
      <router-link exact :to="{ name: 'dashboard' }">Dashboard</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'vulnerabilities' }">CVE's</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'cwes' }">CWE's</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'software' }">Software</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'attribute-types' }">Attributes</router-link>
    </li>
  </ul>
  <ul class="menu-list">
    <li>
      <router-link :to="{ name: 'scrapers' }">Scrapers</router-link>
    </li>
    <router-link :to="{ name: 'standards' }">Standards</router-link>
    <li>
      <ul>
        <router-link tag="li" :to="{ name: 'checkpoints' }"><a>Checkpoints</a></router-link>
      </ul>
    </li>
  </ul>
</aside>  
</template>
<script>
export default {
  
}
</script>